<script setup lang="ts">
    import { CellContentAlignment } from "@/components/KTable/helpers";
    import KCell from "@/components/KTable/KCell.vue";
    import { anmalanStatusIcons } from "@/tabs/Operation/utilsTs";
    import { computed, toRefs } from "vue";

    const props = defineProps<{
        data: unknown;
    }>();

    const { data } = toRefs(props as { data: string });

    const icon = computed(() => anmalanStatusIcons[data.value as keyof typeof anmalanStatusIcons]);
</script>

<template>
    <KCell class="cell-status" :alignContent="CellContentAlignment.Center">
        <template #content>
            <span class="status">
                <img v-if="icon" :src="icon" :alt="data" />
                <span>{{ data }}</span>
            </span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    .cell-status {
        .status {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;

            img {
                width: 1.5rem;
                height: 1.5rem;
                flex-shrink: 0;
            }
        }
    }
</style>
